import { Link } from "react-router-dom";
import { getImageUrl } from "../api";

export default function ProductCard({ product }) {
  const cover = product.images?.length ? product.images[0] : product.image_url;
  return (
    <Link
      to={`/prodotto/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="product-card block group"
    >
      <div className="relative overflow-hidden bg-white">
        <img
          src={getImageUrl(cover)}
          alt={product.name}
          loading="lazy"
          className={`product-img w-full aspect-[3/4] object-cover ${product.sold_out ? "opacity-70 grayscale-[30%]" : ""}`}
        />
        {product.sold_out && (
          <span data-testid={`sold-out-${product.id}`} className="absolute top-3 left-3 z-10 bg-black/90 text-white text-[10px] font-semibold tracking-wide-spaced uppercase px-4 py-2">
            Esaurito
          </span>
        )}
        {product.best_seller && (
          <span data-testid={`best-seller-${product.id}`} className={`absolute z-10 gold-gradient text-white text-[10px] font-semibold tracking-wide-spaced uppercase px-3 py-1.5 ${product.sold_out ? "top-14 left-3" : "top-3 left-3"}`}>
            Best seller
          </span>
        )}
      </div>
      <div className="pt-4 pb-2 text-center">
        <h3 className="font-display text-lg text-[#2C2C2C] leading-snug px-2">{product.name}</h3>
        {product.description && (
          <p className="mt-1 text-xs text-[#8B8578] tracking-wide px-4 line-clamp-2">{product.description}</p>
        )}
        <p className="mt-2 text-sm font-semibold gold-gradient-text tracking-wide">€ {product.price.toFixed(2)}</p>
      </div>
    </Link>
  );
}
